import { useNavigate } from "react-router-dom";
import NotificationBell from "./NotificationBell";
import { useMyTier } from "../features/subscriptions/useMyTier";

type MainNavbarProps = {
  isAuthenticated: boolean;
  isSeller: boolean;
  onLogout: () => void;
};

const TIER_LABELS: Record<string, string> = {
  free: "Free",
  starter: "Starter",
  mid: "Mid",
  premium: "Premium",
  pro: "Pro",
  studio: "Studio",
  elite: "Elite",
};

export default function MainNavbar({
  isAuthenticated,
  isSeller,
  onLogout,
}: MainNavbarProps) {
  const navigate = useNavigate();
  const tier = useMyTier();

  return (
    <header className="app-navbar">
      <div className="app-navbar-inner">
        <button type="button" onClick={() => navigate("/")} className="app-brand">
          <span className="app-brand-mark" aria-hidden="true">
            G
          </span>
          <span className="app-brand-text">Gullivr AI</span>
        </button>

        <nav className="app-nav-actions" aria-label="Main navigation">
          <button type="button" onClick={() => navigate("/chat")} className="btn-primary btn-sm">
            <span aria-hidden="true">✨</span>
            AI Search
          </button>
          <button type="button" onClick={() => navigate("/webinars-news")} className="btn-secondary btn-sm hidden sm:inline-flex">
            Webinars &amp; News
          </button>
          {isAuthenticated && (
            <button type="button" onClick={() => navigate("/enquiries")} className="btn-secondary btn-sm">
              Enquiries
            </button>
          )}
          {isSeller && (
            <>
              <button type="button" onClick={() => navigate("/deals/create")} className="btn-primary btn-sm">
                Create listing
              </button>
              <button type="button" onClick={() => navigate("/news/add")} className="btn-secondary btn-sm hidden md:inline-flex">
                Add news
              </button>
              <button type="button" onClick={() => navigate("/inventory/my")} className="btn-success btn-sm hidden lg:inline-flex">
                Inventory
              </button>
            </>
          )}
          {isAuthenticated ? (
            <>
              <button type="button" onClick={() => navigate("/dm")} className="btn-secondary btn-sm hidden sm:inline-flex">
                Messages
              </button>
              <button type="button" onClick={() => navigate("/subscription")} className="btn-ghost btn-sm hidden sm:inline-flex">
                Plan{tier ? `: ${TIER_LABELS[tier] ?? tier}` : ""}
              </button>
              <button type="button" onClick={() => navigate("/profile")} className="btn-ghost btn-sm">
                Profile
              </button>
              <NotificationBell />
              <button type="button" onClick={onLogout} className="btn-secondary btn-sm">
                Logout
              </button>
            </>
          ) : (
            <>
              <button type="button" onClick={() => navigate("/pricing")} className="btn-ghost btn-sm hidden sm:inline-flex">
                Pricing
              </button>
              <button type="button" onClick={() => navigate("/login")} className="btn-secondary btn-sm">
                Login
              </button>
            </>
          )}
        </nav>
      </div>
    </header>
  );
}
